var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_core.js
// module id = 40
// module chunks = 0